'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_JoinGeneralPracticeResponse(wasPendingUser) {
  this.Lapp_api_JoinGeneralPracticeResponse__f_wasPendingUser = false;
  this.Lapp_api_JoinGeneralPracticeResponse__f_wasPendingUser = wasPendingUser;
}
export { $c_Lapp_api_JoinGeneralPracticeResponse as $c_Lapp_api_JoinGeneralPracticeResponse };
$c_Lapp_api_JoinGeneralPracticeResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.constructor = $c_Lapp_api_JoinGeneralPracticeResponse;
/** @constructor */
function $h_Lapp_api_JoinGeneralPracticeResponse() {
}
export { $h_Lapp_api_JoinGeneralPracticeResponse as $h_Lapp_api_JoinGeneralPracticeResponse };
$h_Lapp_api_JoinGeneralPracticeResponse.prototype = $c_Lapp_api_JoinGeneralPracticeResponse.prototype;
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, 860864250);
  var hash$1 = acc;
  var data = (this.Lapp_api_JoinGeneralPracticeResponse__f_wasPendingUser ? 1231 : 1237);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_api_JoinGeneralPracticeResponse) && (this.Lapp_api_JoinGeneralPracticeResponse__f_wasPendingUser === x$0.Lapp_api_JoinGeneralPracticeResponse__f_wasPendingUser)));
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.productPrefix__T = (function() {
  return "JoinGeneralPracticeResponse";
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_JoinGeneralPracticeResponse__f_wasPendingUser;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_JoinGeneralPracticeResponse.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "wasPendingUser";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_JoinGeneralPracticeResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_JoinGeneralPracticeResponse)));
}
export { $isArrayOf_Lapp_api_JoinGeneralPracticeResponse as $isArrayOf_Lapp_api_JoinGeneralPracticeResponse };
var $d_Lapp_api_JoinGeneralPracticeResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_JoinGeneralPracticeResponse, "app.api.JoinGeneralPracticeResponse", ({
  Lapp_api_JoinGeneralPracticeResponse: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_JoinGeneralPracticeResponse as $d_Lapp_api_JoinGeneralPracticeResponse };
//# sourceMappingURL=app.api.-Join-General-Practice-Response.js.map
